import searchIcon from "../assets/search.svg";
import { useState } from "react";

const Search = ({ handleSearchKeyChange }) => {
	const [search, setSearch] = useState("");
	const [timer, setTimer] = useState(0)

	function debounce(fn, delay) {
		return (...args) => {
			clearTimeout(timer);
	
			setTimer(setTimeout(() => {
				fn(...args);
			}, delay));
		};
	}

	const handleDebounce = debounce((value) => {
		handleSearchKeyChange(value);
	}, 250);

	const handleSearch = (e) => {
		setSearch(e.target.value);

		handleDebounce(e.target.value);
	};

	return (
		<div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
			<input
				className="outline-none border-none bg-gray-50 h-full w-full mr-2"
				type="search"
				name="search"
				value={search}
				onChange={handleSearch}
				placeholder="Search"
			/>
			<img
				className="inline h-6 cursor-pointer"
				src={searchIcon}
				alt="Search"
			/>
		</div>
	);
};;

export default Search;
